class LocalStorage
{
    set(key: string, value: any) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }

    get(key: string) {
        let value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }

    getRawString(key: string): string {
        const value = window.localStorage.getItem(key);
        if (!value || value == 'null') {
            return '';
        }
        return value;
    }
}

const g_localStorage = new LocalStorage()
export default g_localStorage;
